import { runOnFeatureInit } from '@frontend/vanilla/core';

import { GeoLocationAssetService } from './geo-location-asset.service';

export function provide() {
    return [runOnFeatureInit(GeoLocationAssetService)];
}
